<template>
  <div class="box" v-if="this.articleCount > 0">
    <section class="mb-lg-4" v-if="logicCategories.length">
      <div class="page-header h3 filter-title" v-if="this.isMobile" @click="toggleCategoryMenu(logicCategories)">
        <div class="filter-name">
          <i class="fas fa-list"></i> {{ $t('category') }}
        </div>
        <div class="filter-extend">
          <i class="fa-solid fa-chevron-right" :class="{'extend': openCategoryMenu}"></i>
        </div>
      </div>

      <div class="filter-box mb-2 mb-lg-0" v-for="(filter, index) in logicCategories" :key="index" v-show="openCategoryMenu">
        <div :class="{extend: logicValues(filter.id).length > 0}" class="filter-values">
          <div class="filter-value pointer" v-for="(filter_item, i) in logicValues(filter.id)" :key="i">
            <value_fl_cat_select :filter_item="filter_item"/>
          </div>
        </div>
      </div>
    </section>
    <section class="mb-lg-4" v-if="logicFilters.length">
      <!-- Desktop !-->
      <div class="page-header h3 filter-title d-none d-lg-block">
        <div class="filter-name">
          <i class="fas fa-sliders-h"></i> {{ $t('filter_title') }}
        </div>
      </div>

      <!-- Mobile !-->
      <a class="page-header h3 filter-title d-lg-none" data-toggle="collapse" href="#filterBoxes" role="button" :aria-expanded=openFilterMenu aria-controls="filterBoxes">
        <div class="filter-name">
          <i class="fas fa-sliders-h"></i> {{ $t('filter_title') }}
        </div>
        <div class="filter-extend">
          <i class="fa-solid fa-chevron-right"></i>
        </div>
      </a>

      <div class="filter-boxes collapse" :class="{'show': openFilterMenu}" id="filterBoxes">
        <div class="filter-box" v-for="(filter, index) in logicFilters" :key="index">
          <a class="filter-header pointer" @click="toggleFilterBox(filter.id)" data-toggle="collapse" :href="`#filterBox-${filter.id}`" role="button" :aria-expanded="filter.isActive ? 'true' : 'false'" :aria-controls="`filterBox-${filter.id}`">
            <div class="filter-name">{{ filter.displayName }}</div>
            <div class="filter-extend">
              <i class="fa-solid fa-chevron-right"></i>
            </div>
          </a>

          <div class="collapse" :class="{'show': filter.isActive}" :id="`filterBox-${filter.id}`">
            <div v-if="filter.type !== 'range-slider'" :class="{'d-flex flex-wrap': filter.type === 'color'}" class="filter-values">
              <div v-for="(filter_item, i) in logicValues(filter.id)" :key="i" class="filter-value pointer">
                <value_select v-if="filter.type === 'select' || filter.type === 'label'" :filter_item="filter_item"
                              @click="filterBy({id: filter.id, filter: filter_item})"/>
                <value_color v-if="filter.type === 'color'" :filter_item="filter_item"
                             @click="filterBy({id: filter.id, filter: filter_item})"/>
              </div>
            </div>
            <div v-else-if="filter.type === 'range-slider'" class="filter-values pb-2">
              <div class="filter-value mt-3">
                <range_slider :filter="filter"/>
              </div>
            </div>
            <div class="filter-footer justify-content-between" v-if="filter.fl_buttons_showMore || filter.fl_buttons_submit || filter.fl_buttons_reset">
              <!-- Design: FilterMore -->
              <div class="pointer ml-auto" v-if="filter.fl_buttons_showMore">
                <button_showmore @click="togglePinnedItems(filter.id)"/>
              </div>
              <!-- Design: Submit -->
              <div class="pointer" v-if="filter.fl_buttons_submit">
                <button_submit @click="filterBy({id: filter.id, filter: filter})"/>
              </div>
              <!-- Design: Reset -->
              <div class="pointer" v-if="filter.fl_buttons_reset">
                <button_reset @click="filterReset({id: filter.id, filter: filter})"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

import {mapActions, mapGetters} from 'vuex'
import value_select from "./value_select";
import value_color from "./value_color";
import value_fl_cat_select from "./value_fl_cat_select";
import range_slider from "./range_slider";
import button_showmore from "./button_showmore";
import button_submit from "./button_submit";
import button_reset from "./button_reset";

export default {
  name: "findologic-sidebar",
  props: ['filters', 'display', 'useCategoryFilter', 'count'],
  data: () => ({
    isMobile: false,
    openCategoryMenu: true,
    openFilterMenu: true,
    articleCount: 0
  }),
  components: {
    value_select,
    value_color,
    value_fl_cat_select,
    range_slider,
    button_showmore,
    button_submit,
    button_reset,
  },
  created() {
    this.initLogicFilter({
      filters: this.filters,
      display: this.display
    })
    this.initSelector({
      logicFilter: this.filters,
      display: this.display,
      useCategoryFilter: this.useCategoryFilter
    })
    this.articleCount = this.count
  },
  mounted() {
    this.onMobile(() => {
      this.isMobile = false
      this.openFilterMenu = false
      this.openCategoryMenu = false
    })
  },
  watch: {},
  computed: {
    ...mapGetters({
      logicFilters: 'logicFilters/filterTitles',
      logicCategories: 'logicFilters/categoryTitles',
      logicValues: 'logicFilters/values',
    }),
  },
  methods: {
    ...mapActions({
      initLogicFilter: 'logicFilters/init',
      toggleCategoryBox: 'logicFilters/toggleCategoryBox',
      toggleFilterBox: 'logicFilters/toggleFilterBox',
      togglePinnedItems: 'logicFilters/togglePinnedItems',
      initSelector: 'filterSelector/init',
      filterBy: 'filterSelector/by',
      filterReset: 'filterSelector/reset',
    }),
    toggleCategoryMenu(logicCategories) {
      this.openCategoryMenu = !this.openCategoryMenu;
      this.toggleCategoryBox(logicCategories);
    },
    onMobile(fn) {
      if (util.handleResize() !== 'large') {
        fn();
        this.isMobile = true;
      }
    },
  }
}

const util = {
  defaultBreakpoints: {
    small: 744,
    medium: 1060,
    large: Infinity
  },
  handleResize() {
    const clientWidth = window.innerWidth
    if (clientWidth < util.defaultBreakpoints.small) {
      return 'small'
    } else if (clientWidth < util.defaultBreakpoints.medium) {
      return 'medium'
    } else if (clientWidth <= util.defaultBreakpoints.large) {
      return 'large'
    }
  }
}
</script>

<style scoped>

a {
  color: #333;
  text-decoration: none;
}

a[aria-expanded=true] {
  .filter-extend i {
    transform: rotate(90deg);
  }
}

.page-header {
  margin-bottom: 10px;
}

.filter-box {
  border-bottom: 1px solid #dee2e6;
}

.filter-value:last-child {
  padding-bottom: 10px;
}

.filter-box:last-child {
  border-bottom: none;
}

.filter-title {
  display: flex;
  justify-content: space-between;
}

.filter-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px 0;
}

.filter-header .filter-name {
  font-weight: bold;
}

.filter-footer {
  display: flex;
  justify-content: space-between;
  margin: .25em 0;
}

.filter-extend > i {
  font-size: 0.9rem;
  line-height: 1.7rem;
  transform: rotate(0);
  transition: all .2s ease;
}

.filter-extend > i.extend {
  transform: rotate(90deg);
}

.pointer {
  cursor: pointer;
}
</style>
